import axios from "../utilities/api/axiosInstance";
import { printInConsole } from "@utils/devtools/utils";

export async function getPosts({
  postType,
  accessToken,
  homeTs = 0,
  trendingTs = 0,
  clipTs = 0,
  page = 0,
}) {
  /*
  Returns the Posts of home and trending page based on postType
  */

  if (postType === "feed") {
    return getFeedsHome({ accessToken, homeTs, trendingTs, clipTs, page });
  } else if (postType === "trending") {
    return getFeedsTrending({ accessToken, trendingTs, clipTs, page });
  } else return null;
}

export async function getAllFeedHashtags({ accessToken }) {
  let link = "feed/feedHashtags";
  let hashtags = null;
  let error = null;
  const requestOptions = {
    method: "GET",
    url: encodeURI(link),
  };
  if (accessToken) {
    // console.log("accessToken 4", accessToken);

    requestOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(requestOptions).catch((err) => {
    error = err;
  });

  if (response?.data?.success) {
    // console.log(response.data);
    hashtags = response.data?.response;
  }

  // if (response?.data?.success) hashtags = response?.data?.response;
  // else if (response?.data?.message) error = response.data.message;

  return { hashtags, error };
}

export async function getFeedsHome({
  accessToken,
  homeTs = 0,
  trendingTs = 0,
  clipTs = 0,
  page = 0,
}) {
  /*
  Returns the Posts of home page
  accessToken --> required
  */

  let link,
    data = null,
    err = null;
  if (page === 0) {
    link = "posts/web";
  } else {
    link = `posts/web?homeTs=${homeTs}&trendingTs=${trendingTs}&clipTs=${clipTs}&page=${page}`;
  }

  const reqOptions = {};

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(encodeURI(link), reqOptions).catch((error) => {
    err = error;
  });
  //console.log("response", response.data.response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function getHashtagData({ hashtag, accessToken, page }) {
  if (hashtag === "Trending") {
    // try{

    // }catch(e){
    //   console.log(e);
    // }
    let link = "";
    if (page) {
      link = `feed/web/trending/v2?page=${page}`;
    } else {
      link = `feed/web/trending/v2`;
    }

    let data = null;
    let error = null;
    const requestOptions = {
      method: "GET",
      url: encodeURI(link),
    };

    if (accessToken) {
      requestOptions.headers = {
        Authorization: `Bearer ${accessToken}`,
      };
    }

    const response = await axios(requestOptions).catch((err) => {
      error = err;
    });

    if (response?.data?.success) {
      //console.log(response.data.response);
      data = response.data?.response;
    }

    // if (response?.data?.success) hashtags = response?.data?.response;
    // else if (response?.data?.message) error = response.data.message;
    // setFeed(data);
    //console.log("Trending=========",data)
    return { data, error };
  } else {
    let link = "";
    if (page) {
      link = `feed/web/hashtag?hashtag=${hashtag}&page=${page}`;
    } else {
      link = `feed/web/hashtag?hashtag=${hashtag}`;
    }
    let data = null;
    let error = null;
    const requestOptions = {
      method: "GET",
      url: encodeURI(link),
    };
    const response = await axios(requestOptions).catch((err) => {
      error = err;
    });
    if (response?.data?.success) {
      //console.log(response.data.response);
      data = response.data?.response;
    }
    // setFeed(data);
    return { data, error };
  }
}

export async function getFeedsTrending({
  accessToken,
  trendingTs = 0,
  clipTs = 0,
  page = 0,
}) {
  /*
  Returns the Posts of trending page
  */

  let link,
    data = null,
    err = null;
  if (page === 0) {
    link = "feed/web/trending/v2";
  } else {
    link = `feed/web/trending/v2?trendingTs=${trendingTs}&clipTs=${clipTs}`;
  }

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function getClips({
  ts = 0,
  position,
  page = 0,
  accessToken,
  cancelToken,
}) {
  /*
  Returns the Posts of clips page
  ------ Untested --------
  -- parameter to be changed to object
  accessToken --> required
  */

  let link,
    data = null,
    err = null;

  if (ts === 0) {
    link = "feed/web/clips/v2?page=0";
  } else {
    link = `feed/web/clips/v2?clipTs=${ts}&position=${position}&page=${page}`;
  }

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
    cancelToken: cancelToken,
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export async function getHashtagFeeds({
  postType,
  hashtag,
  ts = 0,
  accessToken,
}) {
  /*
  Returns posts with which include "hashtag" value
  postType --> constant indicating feeds/clips

  accessToken --> required
  */

  let link,
    data = null,
    err = null;
  if (ts === 0) {
    link = `feed/web/hashtag?postType=${postType}&hashtag=${hashtag}`;
  } else {
    link = `feed/web/hashtag?postType=${postType}&hashtag=${hashtag}&ts=${ts}`;
  }

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //printInConsole("Hashtag Feeds => ", response);
  if (response?.data?.success) data = response.data.response;

  return { data, err };
}

export async function getSinglePost({ feedID, accessToken }) {
  /*
  Returns the feed-data of image or video post for single-post page
  accessToken --> required
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`feed?feedID=${feedID}`),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  // console.log("Single post data fetched====>",response)

  if (response?.data?.success) data = response.data.response;
  else if (response?.data) err = response.data.message;

  return { data, err };
}

export async function likePost({ feedID, accessToken }) {
  /*
  like feed request 
  
  return true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("feed/like"),
    data: { feedID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Like response => ", response);

  // if (response?.data?.success) return true;

  // return false;
  return response;
}

export async function unlikePost({ feedID, accessToken }) {
  /*
  Unlike feed request 
 
   return true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("feed/like"),
    data: { feedID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Unlike response => ", response);

  //if (response?.data?.success) return true;

  return response;
}

export async function deletePost({ feedID, accessToken }) {
  /*
  Delete feed request --- returns true/false --
  */

  const response = await axios({
    method: "DELETE",
    url: encodeURI("feed"),
    data: { feedID },
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Delete post response => ", response);
  // if (response) return response.data?.success;
  // else return false;
  return response?.data;
}

export async function reportPost({ feedID, accessToken }) {
  /*
  Report feed request --- returns true/false --
  */

  const response = await axios({
    method: "POST",
    url: encodeURI("feed/report"),
    data: { feedID },
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Report response => ", response);
  // if (response && response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function getLikesList({ feedID, ts = 0, accessToken }) {
  /*
  Returns list of users who liked the post
  */
  if (!accessToken) {
    accessToken = "";
  }

  let link = null;
  if (ts === 0) link = `feed/like?feedID=${feedID}`;
  else link = `feed/like?ts=${ts}&feedID=${feedID}`;

  const response = await axios({
    method: "GET",
    url: encodeURI(link),
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  //console.log("LikeList response => ", response);

  if (response) return response.data?.response;
}

export async function getRelatedPosts({ feedID, accessToken, page }) {
  /*
  Returns the feed-data of image or video post for single-post page
  accessToken --> required
  */

  let data = null,
    err = null;

  let link = `feed/v2?page=${page}&feedID=${feedID}`;

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  // console.log("Single post data fetched====>", response);

  if (response?.data?.success) {
    data = response.data.response;
    //  console.log(data);
  } else if (!response?.data) {
    err = response.data.message;
    //console.log(err);
  }

  return { data, err };
}



export async function getSearchedCommunityEvent({
  accessToken,
  search,
  ts = 0,
  page = 0,
}) {
  /*
  Returns the Posts of trending page
  accessToken --> required
  */

  let link,
    data = null,
    err = null;
  if (page === 0) {
    link = `kriya/search?query=${search}`;
  } else {
    //link = `feed/web/trending?trendingTs=${trendingTs}&clipTs=${clipTs}&page=${page}`;
    link = `kriya/search?ts=${ts}&page=${page}&query=${search}`;
  }

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
  });

  // console.log("Events====>",response)

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}
